/**
 * Erzeugt aus einem Briefing eine .ics-Kalenderdatei und lädt sie herunter.
 * briefing: { title, date (ISO "JJJJ-MM-TT"), time_label ("18:00 Uhr"), duration ("60 Min"), speaker }
 */
export function downloadBriefingIcs(briefing) {
  const timeMatch = (briefing.time_label || "").match(/(\d{1,2}):(\d{2})/);
  const [h, m] = timeMatch ? [Number(timeMatch[1]), Number(timeMatch[2])] : [18, 0];
  const durMatch = (briefing.duration || "").match(/(\d+)/);
  const minutes = durMatch ? Number(durMatch[1]) : 60;

  const start = new Date(briefing.date);
  start.setHours(h, m, 0, 0);
  const end = new Date(start.getTime() + minutes * 60000);

  const fmt = (d) =>
    `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, "0")}${String(d.getDate()).padStart(2, "0")}T${String(d.getHours()).padStart(2, "0")}${String(d.getMinutes()).padStart(2, "0")}00`;

  const ics = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Dickies-Campus//Helden-Briefing//DE",
    "BEGIN:VEVENT",
    `UID:${briefing.id}@dickies-helden.de`,
    `DTSTART:${fmt(start)}`,
    `DTEND:${fmt(end)}`,
    `SUMMARY:Helden-Briefing · ${briefing.title}`,
    `DESCRIPTION:Live mit ${briefing.speaker} · Zugang über den Dickies-Campus`,
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");

  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "helden-briefing.ics";
  a.click();
  URL.revokeObjectURL(url);
}

export function isUpcoming(briefing) {
  const d = new Date(briefing.date);
  d.setHours(23, 59, 59, 999);
  return d >= new Date();
}
